module.exports = __webpack_public_path__ + "static/media/coupon-icon-k.f01cf0af.svg";